module.exports = __webpack_public_path__ + "static/media/centro2.508103fc.jpg";